/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Format_OptionsInputs */



/**
* | output |
* | --- |
* | "Open auto format options" |
*
* @param {Auto_Format_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_format_options = /** @type {((inputs?: Auto_Format_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Format_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir les options de format automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Formatierungsoptionen öffnen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri le opzioni di formattazione automatica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открыть параметры автоформатирования")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abrir las opciones de formato automático")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("打开自动格式化选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動フォーマットオプションを開く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑटो फॉर्मेट विकल्प खोलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abra as opções de formatação automática.")
	return /** @type {LocalizedString} */ ("Open auto format options")
});